import { NodeModel } from "../_model/NodeModel";
import { DecorationSugarCentrifugue } from "./decorationSugarCentrifugue";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class SugarCentrifugue extends NodeModel {
    constructor() {
        super("SugarCentrifugue");

        this.type = new Types().SugarCentrifugue;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 100;
        this.width = 200;
        this.selectedMass = null;
        this.srcImg = require("@/assets/Fluxogramas/Centrifuga_Continua.png");
        this.data = [new Properties({...this })];
        this.jokerCaption = {};


        this.decorate = async function(callback) {
            this.decorator = new DecorationSugarCentrifugue();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new SugarCentrifugue()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.selectedMass = this.selectedMass;
            cloned.readOnly = this.readOnly;
            cloned.expressionVisible = this.expressionVisible
            cloned.jokerCaption = this.jokerCaption
            cloned.data = this.data.map(d => d.clone());

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.selectedMass = node.selectedMass
            this.jokerCaption = node.jokerCaption
            this.data = node.data.map(d => new Properties({...d }));
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs
            }
            this.selectedMass = node.selectedMass
            this.jokerCaption = node.jokerCaption
        }

        // Para caso o nó tenha connections.
        // this.removeConnection = (connectionId) => {
        //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
        // }
    }
}

export { SugarCentrifugue };